module.exports = __webpack_public_path__ + "img/icon-download.3c0283b2.svg";